import * as types from "../actions/actionTypes";
import createEntityReducer from "./createEntityReducer";

export default createEntityReducer({
  entity: "ledgerentry",
  listKey: "entries",
  itemKey: "entry",
  getAll: types.GET_ALL_LEDGER_ENTRYS,
  getAllResponse: types.GET_ALL_LEDGER_ENTRYS_RESPONSE,
  getByIdResponse: types.GET_LEDGER_ENTRY_BY_ID_RESPONSE,
});
